import { renderRoutes } from "react-router-config";

const EmptyLayout = ({ route }: any) => {
  return <>{renderRoutes(route.routes)}</>;
};

export default EmptyLayout;
